import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroQuorum extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';

    get label() {
        return 'Quórum';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        let composicao = [];
        if (registro.composicao && registro.composicao.length > 0) {
            composicao = registro.composicao
                .filter((comp) => comp.magistrado.nome)
                .map((comp) => comp.magistrado.nome.trim() + ' (' + comp.magistrado.sigla + ')');
        }
        return composicao;
    }
}
